import { contentEditable } from '@yola/ws-sdk';

const findBlockElementFromNode = (node, { isNodeMounted = true } = {}) => {
  const firstTextNode = contentEditable.helpers.findFirstTextNode(node, true);
  return contentEditable.helpers.findClosestEditableElement(firstTextNode, { isNodeMounted });
};

export default findBlockElementFromNode;
